import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const crawlOrganizationWebsite = (organizationWebsiteURL: string) =>
  createGenericDispatcher<Array<string>>({
    name: 'CRAWL_ORGANIZATION_WEBSITE',
    loadFunction: () =>
      Api.post('/organization-scraped-image/crawl-website', {
        body: JSON.stringify({ organizationWebsiteURL }),
      }),
    args: { organizationWebsiteURL },
  });
